// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1JZ2I","item":"PaymentsMobile_item__3yIMq","label":"PaymentsMobile_label__2glHJ","amount":"PaymentsMobile_amount__2s-Zc"};